export const MaterialGenericoFiltro = Object.freeze({
  TODOS: 'TODOS',
  GENERICOS: 'GENERICOS',
  NO_GENERICOS: 'NO_GENERICOS',
});

export const MaterialGenericoFiltroOptions = [
  { Codigo: MaterialGenericoFiltro.TODOS, Descripcion: 'Todos' },
  { Codigo: MaterialGenericoFiltro.GENERICOS, Descripcion: 'Genéricos' },
  { Codigo: MaterialGenericoFiltro.NO_GENERICOS, Descripcion: 'No genéricos' },
];
